import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/js/utils.js'
import 'jquery-validation';
require("@nathanvda/cocoon");

$.validator.setDefaults({
  onkeyup: false,
  errorElement: 'div',
  errorClass: 'invalid-feedback',

  errorPlacement: function (error, element) {
    element.closest('.form-group').append(error);
  },
  highlight: function (element, errorClass, validClass) {
    $(element).removeClass('is-valid').addClass('is-invalid');
  },
  unhighlight: function (element, errorClass, validClass) {
    $(element).removeClass('is-invalid').addClass('is-valid');
    $(element).next('.invalid-feedback').remove();
  }
});

$.validator.addMethod("notEqualTo", function (value, element, param) {
  return this.optional(element) || !$.validator.methods.equalTo.call(this, value, element, param);
}, "Your last name cannot be the same as your first name.");

document.addEventListener("DOMContentLoaded", function () {

  check_to_hide_or_show_remove_link();

  $('#selected_pathway_subjects')
  .on('cocoon:after-insert', function() {
    check_to_hide_or_show_add_link();
    check_to_hide_or_show_remove_link();
  })
  .on("cocoon:after-remove", function() {
    check_to_hide_or_show_add_link();
    check_to_hide_or_show_remove_link();
  });
  
  // Getting Country data from HTTP header
  var visitor_country = $("#visitor-country").data('visitor-country') || "my";
  
  // Initializing Phone Number
  if ($("#course_search_phone_num").length) {
    var input = document.querySelector("#course_search_phone_num");
    var user_telephone_iti = intlTelInput(input, {
      initialCountry: visitor_country,
      autoPlaceholder: "off",
      separateDialCode: true,
      customContainer: "w-100",
      preferredCountries: ["my", "sg"],
      utilsScript: "../intl-tel-input/build/js/utils.js"
    });

    if ($("#course_search_phone_num").val() != "") {
      user_telephone_iti.setNumber($("#course_search_phone_num").val());
    }

    jQuery.validator.addMethod("phone", function (value, element) {
      return this.optional(element) || user_telephone_iti.isValidNumber();
    }, "Please enter a valid phone number.");

  }

  $("#courseSearchForm").validate({
    submitHandler: function (form) {
      $("#course_search_phone_num").val(user_telephone_iti.getNumber());
      $("#CourseSearchSubmitBtn").prop("disabled", true).html("<span class='spinner-border spinner-border-sm' role='status' aria-hidden='true'></span> Submitting...");
      form.submit();
    },
    rules: {
      'course_search[first_name]': { required: true },
      'course_search[last_name]': { notEqualTo: "#course_search_first_name" },
      'course_search[email]': { email: true },
      'course_search[phone_num]': { phone: true },
      'course_search[selected_pathway_subjects_attributes][][]': { required: true }
    }
  });
});

function check_to_hide_or_show_add_link() {
  if ($('#selected_pathway_subjects .nested-fields:visible').length == 3) {
    $('#add-subjects a').hide();
  } else {
    $('#add-subjects a').show();
  }
}

function check_to_hide_or_show_remove_link() {
  if ($('#selected_pathway_subjects .nested-fields:visible').length == 1) {
    $('a.remove_fields').hide();
  } else {
    $('a.remove_fields').show();
  }
}